module.exports = __webpack_public_path__ + "img/chest_male_anterior.375ed97e.png";